export default function buildForm(formType) {
    let baseForm = {
        wrapper: "<table class='webchat__table'></table>",
        inputs: [
            {
                id: "cx_webchat_form_firstname",
                name: "firstname",
                maxlength: "100",
                placeholder: "First Name *",
                //"label": "First Name",
                validate: function (
                    event,
                    form,
                    input,
                    label,
                    $,
                    CXBus,
                    Common
                ) {
                    if (event.type != "blur" && event.type != "keyup")
                        if (input != undefined) {
                            if (
                                input[0].value == "" ||
                                input[0].value == undefined
                            ) {
                                window._genesys.widgets.common.showAlert(
                                    $(".cx-widget.cx-webchat"),
                                    {
                                        text: "First Name is required.",
                                        buttonText: "Ok",
                                    }
                                );
                                return false;
                            } else return true;
                        }
                    return true;
                },
                wrapper: "<tr><td colspan='2'>{input}</td></tr>",
            },
            {
                id: "cx_webchat_form_lastname",
                name: "lastname",
                maxlength: "100",
                placeholder: "Last Name *",
                //"label": "Last Name",
                validate: function (
                    event,
                    form,
                    input,
                    label,
                    $,
                    CXBus,
                    Common
                ) {
                    if (event.type != "blur" && event.type != "keyup")
                        if (input != undefined) {
                            if (
                                input[0].value == "" ||
                                input[0].value == undefined
                            ) {
                                window._genesys.widgets.common.showAlert(
                                    $(".cx-widget.cx-webchat"),
                                    {
                                        text: "Last Name is required.",
                                        buttonText: "Ok",
                                    }
                                );
                                return false;
                            } else return true;
                        }
                    return true;
                },
                wrapper: "<tr><td colspan='2'>{input}</td></tr>",
            },
            {
                id: "cx_webchat_form_phonenumber",
                name: "PhoneNumber",
                maxlength: "10",
                placeholder: "Phone Number *",
                //"label": "Phone Number",
                onkeypress: function (event) {
                    // To allow only number inputs
                    return (
                        (event.charCode >= 48 && event.charCode <= 57) ||
                        event.charCode == 43
                    );
                },
                validate: function (
                    event,
                    form,
                    input,
                    label,
                    $,
                    CXBus,
                    Common
                ) {
                    if (
                        event.type != "blur" &&
                        event.type != "keyup" &&
                        event.type != "change"
                    )
                        if (input != undefined) {
                            if (
                                input[0].value == "" ||
                                input[0].value == undefined
                            ) {
                                window._genesys.widgets.common.showAlert(
                                    $(".cx-widget.cx-webchat"),
                                    {
                                        text: "Phone Number is required.",
                                        buttonText: "Ok",
                                    }
                                );
                                return false;
                            } else if (input[0].value.length < 10) {
                                window._genesys.widgets.common.showAlert(
                                    $(".cx-widget.cx-webchat"),
                                    {
                                        text: "Please enter a 10-digit Phone Number.",
                                        buttonText: "Ok",
                                    }
                                );
                                return false;
                            }
                            return true;
                        }
                    return true;
                },
                wrapper: "<tr><td colspan='2'>{input}</td></tr>",
            },
            {
                id: "cx_webchat_form_email",
                name: "email",
                maxlength: "100",
                placeholder: "Email Address",
                wrapper: "<tr><td colspan='2'>{input}</td></tr>",
            },
        ],
    };

    let inputs = {
        select: {
            id: "cx_webchat_form_subject",
            name: "subject",
            maxlength: "100",
            placeholder: "Optional",
            label: "none",
            type: "select",
            options: [],
            validate: function (event, form, input, label, $, CXBus, Common) {
                if (event.type != "blur" && event.type != "keyup")
                    if (input != undefined) {
                        if (
                            input[0].value == "" ||
                            input[0].value == undefined
                        ) {
                            window._genesys.widgets.common.showAlert(
                                $(".cx-widget.cx-webchat"),
                                {
                                    text: "Subject is required.",
                                    buttonText: "Ok",
                                }
                            );
                            return false;
                        } else return true;
                    }
                return true;
            },
            wrapper: "<tr><td colspan='2'>{input}</td></tr>",
        },
        options: {
            mobile: [
                {
                    text: "Please select a subject *",
                    value: "",
                },
                {
                    text: "Sales New or Existing Customer",
                    value: "mobile-sales",
                },
                {
                    text: "Account Help, Customer Care, and Billing",
                    value: "mobile-account",
                },
                {
                    text: "Troubleshoot your Breezeline Product(s)",
                    value: "mobile-troubleshoot",
                },
            ],
            residential: [
                {
                    text: "Please select a subject *",
                    value: "",
                },
                {
                    text: "Sales New or Existing Customer",
                    value: "home-sales",
                },
                {
                    text: "Account Help, Customer Care, and Billing",
                    value: "home-account",
                },
                {
                    text: "Troubleshoot your Breezeline Product(s)",
                    value: "home-troubleshoot",
                },
            ],
            business: [
                {
                    text: "Please select a subject *",
                    value: "",
                },
                {
                    text: "Sales New or Existing Customer",
                    value: "business-sales",
                },
                {
                    text: "Account Help, Customer Care, and Billing",
                    value: "business-account",
                },
                {
                    text: "Troubleshoot your Breezeline Product(s)",
                    value: "business-troubleshoot",
                },
            ],
        },
    };

    if (formType === "residential") {
        inputs.select.options = inputs.options.residential;
        baseForm.inputs.push(inputs.select);
    }

    if (formType === "business") {
        inputs.select.options = inputs.options.business;
        baseForm.inputs.push(inputs.select);
    }

    if (formType === "mobile") {
        inputs.select.options = inputs.options.mobile;
        baseForm.inputs.push(inputs.select);
    }

    return baseForm;
}
